<button
	mat-button
	class="column-selector-trigger"
	[matMenuTriggerFor]="columnMenu"
	#menuTrigger="matMenuTrigger"
	[attr.aria-label]="'database_view.columns.select' | transloco"
	(click)="openMenu()"
>
	<span>{{ 'database_view.columns.select' | transloco }}</span>
	@if (options().length > 0) {
		<span class="column-selector-count">{{ selectedCount() }} / {{ options().length }}</span>
	}
	<mat-icon class="column-selector-arrow" [class.is-open]="menuTrigger.menuOpen">keyboard_arrow_down</mat-icon>
</button>

<mat-menu #columnMenu="matMenu" class="column-selector-menu" (closed)="onMenuClosed()">
	<div
		class="column-selector-panel"
		tabindex="0"
		(click)="$event.stopPropagation()"
		(keydown)="$event.stopPropagation()"
	>
		<div class="column-selector-options" role="group" [attr.aria-label]="'database_view.columns.select' | transloco">
			@for (option of options(); track option.schemaId) {
				<mat-checkbox
					[checked]="isSelected(option.schemaId)"
					[disabled]="applying()"
					(change)="toggle(option.schemaId, $event.checked)"
				>
					{{ option.label }}
				</mat-checkbox>
			}
		</div>
		<div class="column-selector-footer">
			<div class="column-selector-bulk-actions">
				<lvr-button
					variant="secondary"
					[label]="'database_view.columns.select_all' | transloco"
					[disabled]="!canSelectAll()"
					(clicked)="$event.stopPropagation(); selectAll()"
				></lvr-button>
				<lvr-button
					variant="secondary"
					[label]="'database_view.columns.clear_all' | transloco"
					[disabled]="!canClearAll()"
					(clicked)="$event.stopPropagation(); clearAll()"
				></lvr-button>
			</div>
			<div class="column-selector-action-row">
				@if (pendingCount() > 0) {
					<span class="column-selector-pending-count">{{
						(pendingCount() === 1 ? 'database_view.columns.selected_count_one' : 'database_view.columns.selected_count')
							| transloco: { count: pendingCount() }
					}}</span>
				}
				<lvr-button
					class="column-selector-apply"
					variant="primary"
					[label]="'database_view.columns.apply' | transloco"
					[loading]="applying()"
					[ariaLabel]="applying() ? ('database_view.columns.applying' | transloco) : null"
					[disabled]="!canApply()"
					(clicked)="$event.stopPropagation(); apply()"
				></lvr-button>
			</div>
		</div>
	</div>
</mat-menu>
